<div class="ui-g loyalty-cluster" *ngIf="reasonService && render.datatable">

  <div class="ui-g-12">

    <app-kontable title = "{{ 'reason.reason' | translate }}"
                  [columns] = "[ 'id', 'description', 'reason_code',
                    { field: 'sign_pid', title: 'reason.sign_id', filterType: customFilter,  filterTemplate: signFilter, bodyTemplate: signTemplate },
                    { field: 'type_pid', title: 'common.type', filterType: customFilter, filterTemplate: typeFilter , bodyTemplate: typeTemplate  },
                    { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: customFilter, filterTemplate: stateFilter}
                    ]"
                  [titles] = "['common.id', 'common.description', 'reason.reason_code']"
                  [paginationType]="serverPagination"
                  [showInfoButton]="false"
                  [showRecoverButton]="true"
                  [showGlobalFilter]="false"
                  [showDetailsButton]="false"
                  [showAddButton]="true"
                  [service]="reasonService"
                  [(fireNewDataAvailable)]="newDataAvailable"
                  [servicePermissions]="reasonPermission"
                  (onAdd)="addNew($event)"
                  (onEdit)="edit($event)"
                  (onRecover)="recover($event)"
                  (onRemove)="remove($event)" #table>



        <ng-template #typeTemplate let-col>
          <span>{{col.typeDescription}}</span>
        </ng-template>

        <ng-template #signTemplate let-col>
          <span>{{col.signDescription}}</span>
        </ng-template>
      <ng-template #signFilter data-testid="signFilter" let-col>
        <p-dropdown [options]="paramsSign" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>

      <ng-template #typeFilter data-testid="typeFilter" let-col>
        <p-dropdown [options]="paramsType" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>

      <ng-template #stateTemplate data-testid="stateTemplate" let-row class="deleted-row">
          <span *ngIf="row.flg_state == '1'" class="fa fa-trash-o" title="{{'common.deleted' | translate}}"></span>
          <span *ngIf="row.flg_state == '2'" class="fa fa-ban" title="{{'common.suspended' | translate}}"></span>
      </ng-template>

      <ng-template #stateFilter data-testid="stateFilter" let-col>
          <p-dropdown [options]="listStates" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>

    </app-kontable>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reason/loyalty-reason.component.html